<div class='team'>
  <!-- Header section for the Team card -->
  <div class="row" style="margin: 0px;">
  <div class="col-md-2 color" [ngStyle]='{"background-color": team.teamColor}'></div>
  <div class='col-md-10 header'>
    <div class='title'>
      <div class='main'>
        {{team.name}}</div>
      <div class='sub'>{{'teamManagement.flatRateHours'| translate}}: <span class="count">{{teamFlatRateHours$ | async}}</span></div>
    </div>
    <div class='actions'>
      <asp-icon name="ic-20-utility-edit.svg"
                width="1rem"
                class="edit-icon"
                color="rgba(14,19,25,0.8)"
                title="{{'teamManagement.editTheTeamDetails'| translate}}"
                (click)="onEdit()">
      </asp-icon>
      <asp-icon name="ic-20-utility-delete-trash.svg"
                width="1rem"
                class="delete-icon"
                title="{{'teamManagement.deleteTeam'| translate}}"
                color='rgba(14,19,25,0.8)'
                (click)="onDelete()">
      </asp-icon>
    </div>
  </div>
</div>

  <div class="employees">
    <multi-drag-drop
      [items]="employees$ | async"
      emptyText="{{'teamManagement.dragServiceAdvisorsFromTheSidebarAndDropThemHereToStartCreatingYourTeam'| translate}}."
      (itemsAdded)="itemsAdded($event, 2)"
      (itemsUpdated)="itemsUpdated($event, 2)"
      (itemsRemoved)="itemsRemoved($event, 2)"
      (cdkDragStarted)="cdkdragStarted($event)"
    >
      <ng-template let-item>
        <app-employee  *ngIf="item" [employee]="item"></app-employee>
      </ng-template>
    </multi-drag-drop>
  </div>

</div>
